import React, { useState } from "react";
import axios from "axios";
import "./App.css";

const App = () => {
  const [prompt, setPrompt] = useState("");
  const [isLoading, setLoading] = useState(false);

  const handleGenerate = async () => {
    try {
      setLoading(true);
      const response = await axios.post(
        "https://aonraza123.pythonanywhere.com/generate",
        { prompt },
        {
          responseType: "blob",
        }
      );

      const url = window.URL.createObjectURL(
        new Blob([response.data], { type: response.data.type })
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "presentation.pptx");
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error("Error generating presentation:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleGenerate();
    }
  };

  return (
    <div className="app-container">
      <header className="header">
        <h1>AI Presentation Maker</h1>
      </header>
      <main className="main-content">
        <input
          type="text"
          value={prompt}
          onChange={(e) => setPrompt(e.target.value)}
          onKeyPress={handleKeyPress}
          placeholder="Enter your prompt here"
          className="input-prompt"
          disabled={isLoading}
        />
        <button
          onClick={handleGenerate}
          className="generate-button"
          disabled={isLoading}
        >
          {isLoading ? "Generating..." : "Generate"}
        </button>
      </main>
      <footer className="footer">Made by Syed Aon Raza</footer>
    </div>
  );
};

export default App;
